import { gql } from 'graphql-tag'

export default gql`
  fragment GlobalDataDeviceTypeFragment on GlobalDataDeviceType {
    sys {
      id
    }
    contentType: __typename
    internalName
    name
  }
`
